import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.chineseparkserver.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_ASYNC: `${uid}.saveAsync`,
    SAVE_SUCCESS: `${uid}.saveSuccess`,
    SAVE_FAILURE: `${uid}.saveFailure`,
};

export { ActionTypes };
